import type { IOrganizationExchange } from './OrganizationExchange.interface';
import OrganizationExchangeEMail from './OrganizationExchangeEMail';

export default class OrganizationExchange implements IOrganizationExchange {
  name: string;
  phone: string;
  eMail: OrganizationExchangeEMail;
  additionalEmailText: string;

  static build = (data: IOrganizationExchange) => new OrganizationExchange(data);
  static blank = () => new OrganizationExchange();

  /**
   * Constructor
   * @param {IOrganizationExchange} data
   */
  constructor(data?: IOrganizationExchange) {
    this.name = data?.name || undefined;
    this.phone = data?.phone || undefined;
    this.eMail = new OrganizationExchangeEMail(data?.eMail);
    this.additionalEmailText = data?.additionalEmailText || undefined;
  }
}
